import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		min-height: 100dvh;
		display: flex;
		flex-direction: column;
		background-color: ${({theme}) => theme.color.white};

		@media (min-width: ${({theme}) => theme.breakpoints.desktop}) {
			min-width: 1585px;
		}
	`,
	ContentWrapper: styled.div`
		display: flex;
		flex-grow: 1;
		position: relative;
	`,
}

export default Style
